import { render } from "./ColorSelector.vue?vue&type=template&id=11ff9056&scoped=true"
import script from "./ColorSelector.vue?vue&type=script&lang=js"
export * from "./ColorSelector.vue?vue&type=script&lang=js"

import "./ColorSelector.vue?vue&type=style&index=0&id=11ff9056&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11ff9056"

export default script